import request from '@/utils/request'

// 查询历史搜索列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/order/record/page',
        method: 'get',
        params: query,
    })
}
 
// 记录详情
export function getObj(data) {
    return request({
        url: '/upkeep/order/record/detail?id=' + data.id,
        method: 'get',
    })
}
